import { defineComponent as _defineComponent } from 'vue'
interface Props {
    loading?: boolean;
    disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'submit',
  props: {
    loading: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})